// Returns a stable key for a dataChart item, used to index live Marker instances.
// Prefers the configured business id (when dataNames contains "id"); otherwise
// falls back to a lat|lng|index composite that is unique within a render pass.
export const keyForItem = (item, index, { valueData, dataNames, latKey, lngKey }) => {
  const idIndex = dataNames?.findIndex(n => n === "id")
  if (idIndex !== undefined && idIndex !== -1) {
    const idField = valueData?.[idIndex]?.valueId ?? valueData?.[idIndex]
    const idValue = idField ? item?.[idField] : undefined
    if (idValue !== undefined && idValue !== null && idValue !== "") {
      return String(idValue)
    }
  }
  const lat = item?.[latKey]
  const lng = item?.[lngKey]
  return `${lat}|${lng}|${index}`
}
